var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.985107 15C0.985107 6.74046 7.68079 0 15.9403 0C24.1999 0 30.8956 6.74046 30.8956 15C30.8956 23.2595 24.1999 30 15.9403 30C7.68079 30 0.985107 23.2595 0.985107 15Z",
    fill: "url(#paint0_linear_2_892)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97607 14.9268C3.97607 8.35585 9.30289 3 15.8739 3C22.4448 3 27.7716 8.35585 27.7716 14.9268C27.7716 21.4978 22.4448 26.8536 15.8739 26.8536C9.30289 26.8536 3.97607 21.4978 3.97607 14.9268Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8739 1.5C8.46971 1.5 2.47607 7.53219 2.47607 14.9268C2.47607 22.3214 8.46971 28.3536 15.8739 28.3536C23.278 28.3536 29.2716 22.3214 29.2716 14.9268C29.2716 7.53219 23.278 1.5 15.8739 1.5Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75513 15.0734C6.75513 9.95666 10.903 5.78613 16.0198 5.78613C21.1365 5.78613 25.2844 9.95666 25.2844 15.0734C25.2844 20.1901 21.1365 24.3606 16.0198 24.3606C10.903 24.3606 6.75513 20.1901 6.75513 15.0734Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7937 17.4709L20.089 11.3066C20.5065 10.8978 21.1917 10.8978 21.6093 11.3066C22.0268 11.7155 22.0268 12.3759 21.6093 12.7848L14.5539 19.6934C14.1363 20.1022 13.4619 20.1022 13.0443 19.6934L10.2714 16.9782C9.85387 16.5693 9.85387 15.9089 10.2714 15.5C10.689 15.0911 11.3634 15.0911 11.781 15.5L13.7937 17.4709Z",
    fill: "url(#paint1_linear_2_892)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_892",
    x1: 15.9403,
    y1: 0,
    x2: 15.9403,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3177FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_892",
    x1: 9.95825,
    y1: 15.5,
    x2: 22.9244,
    y2: 16.1971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3177FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrePost);
export default __webpack_public_path__ + "static/media/pre-post.edfbe9e53dbe57d51df9b0d58d342923.svg";
export { ForwardRef as ReactComponent };